export default __webpack_public_path__ + "static/Right-To-FarmProvisions-19ba49e49c84ea6efed3a79ea920b16b.jpg";